import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import EvidencijeObrazac8Dodavanje from "./EvidencijeObrazac8Dodavanje";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

function EvidencijeObrazac8() {
  const [data, setData] = useState([]);
  const [isDodavanje, setIsDodavanje] = useState(false);
  const [header, setHeader] = useState({ name: "", address: "", pib: "" });

  const { selectedMainEntity, baseUrl, loggedUser, apiKey } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data: res } = await axios.post(
        `${baseUrl}/evidencija8/read.php`,
        { company_id: selectedMainEntity.company_id }
      );
      if (res.status === 200) setData(res.data);
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
  }, [selectedMainEntity]);

  useEffect(() => {
    const fetchHeader = async () => {
      const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
      if (!id || !loggedUser?.id) return;
      try {
        const { data: res } = await axios.post(`${baseUrl}/companies/readCompanyDetails.php`, {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: id,
        });
        if (res.status === 200) setHeader({
          name: res.data.company_name,
          address: res.data.company_address,
          pib: res.data.pib
        });
      } catch (e) { console.error(e); }
    };
    fetchHeader();
  }, [selectedMainEntity, loggedUser?.id]);

  const handlePrint = () => {
    const el = document.getElementById("print-obrazac8");
    if (!el) return;

    const useSignature = window.confirm(
      "Da li želite da dodate stranicu sa potpisom?"
    );

    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div style="width:280mm;height:190mm;margin:0 auto;position:relative;background:#fff;"><img src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);max-width:100%;display:block;"/></div></div>`;
    }

    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Popup blokiran.");
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
          <meta charset="utf-8"/>
          <style>
            @page { size: A4 landscape; margin: 10mm; }
            body { margin: 0; padding: 0; font-family: sans-serif; font-size: 11px; }
            table { width: 100%; border-collapse: collapse; table-layout: fixed; }
            td, th { border: 1px solid black; padding: 4px; font-size: 10px; vertical-align: top; text-align: center; word-wrap: break-word; }
            hr { width: 80%; margin: 0 auto 5px; border: 0; border-top: 1px solid black; }
            .header-info { display: flex; justify-content: space-between; margin-bottom: 20px; }
            .header-info div { width: 30%; text-align: center; }
          </style>
        </head>
        <body>
          ${el.innerHTML}
          ${signatureHtml}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <div
      style={{
        fontSize: "12px",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "rgb(204,204,204)",
      }}
    >
      <div
        id="print-obrazac8"
        style={{
          overflowY: "auto",
          height: isDodavanje ? "calc(100% - 100px)" : "100%",
          backgroundColor: "white",
          padding: "40px",
          border: "1.5px solid #9f9f9f",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            textAlign: "center",
            textTransform: "uppercase",
            fontSize: "14px"
          }}
        >
          <div>Образац 8</div>
          <div>ЕВИДЕНЦИЈА О ИЗВРШЕНИМ ПРЕГЛЕДИМА И ПРОВЕРАМА ОПРЕМЕ ЗА РАД</div>
        </div>
        <br />
        <br />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "30%", textAlign: "center" }}>
            {header.name || selectedMainEntity.company_name}
            <hr style={{ border: "0", borderTop: "1px solid black", marginBottom: "5px" }} />
            Пословно име послодавца
          </div>
          <div style={{ width: "30%", textAlign: "center" }}>
            {header.address}
            <hr style={{ border: "0", borderTop: "1px solid black", marginBottom: "5px" }} />
            Адреса седишта послодавца
          </div>
          <div style={{ width: "30%", textAlign: "center" }}>
            {header.pib}
            <hr style={{ border: "0", borderTop: "1px solid black", marginBottom: "5px" }} />
            ПИБ послодавца
          </div>
        </div>
        <br />
        <br />

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
              <td style={{ ...styles.cell, width: "5%" , fontSize: "13px"}}>Редни број</td>
              <td style={{ ...styles.cell, width: "35%", fontSize: "13px" }}>
                Подаци о опреми за рад (врста, фабрички број, година, локација и намена)
              </td>
              <td style={{ ...styles.cell, fontSize: "13px", width: "15%" }}>Број стручног налаза</td>
              <td style={{ ...styles.cell, fontSize: "13px", width: "15%" }}>Датум прегледа</td>
              <td style={{ ...styles.cell, fontSize: "13px", width: "15%" }}>Датум следећег прегледа</td>
              <td style={{ ...styles.cell, fontSize: "13px", width: "15%" }}>Напомена</td>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={item.id}>
                <td style={{ ...styles.cell, textAlign: "center" }}>{i + 1}.</td>
                <td style={{ ...styles.cell, textAlign: "left" }}>{item.oprema_podaci}</td>
                <td style={{ ...styles.cell, textAlign: "center" }}>{item.broj_nalaza}</td>
                <td style={{ ...styles.cell, textAlign: "center" }}>{item.datum_pregleda}</td>
                <td style={{ ...styles.cell, textAlign: "center" }}>{item.datum_sledeceg}</td>
                <td style={styles.cell}>{item.napomena}</td>
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                {Array.from({ length: 6 }).map((_, i) => (
                  <td key={i} style={{ ...styles.cell, height: "30px" }}></td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
        <br />
        <br />

        <div
          style={{
            display: "flex",
            marginTop: "40px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "45%", textAlign: "center" }}>
            <hr style={{ border: "0", borderTop: "1px solid black", marginBottom: "5px" }} />
            Саветник/сарадник за БЗР
          </div>
          <div style={{ width: "30%", textAlign: "center" }}>
            <hr style={{ border: "0", borderTop: "1px solid black", marginBottom: "5px" }} />
            Послодавац
          </div>
        </div>
      </div>

      <div style={{ marginTop: "15px", padding: "0 10px 10px 10px" }}>
        {isDodavanje ? (
          <EvidencijeObrazac8Dodavanje
            setIsDodavanje={setIsDodavanje}
            onRefresh={fetchData}
          />
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={handlePrint}>
                <Button activation={true} style={styles.button}>
                  ШТАМПАЈ
                </Button>
              </div>
              <Button activation={true} style={styles.button}>
                ПОШАЉИ
              </Button>
            </div>
            <div onClick={() => setIsDodavanje(true)}>
              <Button activation={true} style={styles.button}>
                ДОДАЈ
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EvidencijeObrazac8;